import { TableCell, TableRow } from '../../table/components'
import { useDataTable } from '../dataTable.context'

export const DataTableRow = ({ row }) => {
  const { getRowProps, getCellProps } = useDataTable()
  const { isSelected, isHoverable, ...props } = getRowProps(row)

  return (
    <TableRow hover={isHoverable} selected={isSelected} {...props}>
      {row.getVisibleCells().map(cell => {
        return (
          <TableCell key={cell.id} {...getCellProps(cell)}>
            {cell.renderCell()}
          </TableCell>
        )
      })}
    </TableRow>
  )
}
